import { SetupPermission } from "../../../../types";
import {
  SETUP_PERMISSIONS_ALL,
  SETUP_PERMISSIONS_MAP,
  SETUP_PERMISSIONS_NONE,
} from "../../constants";

export const getSetupPermissions = ({
  code,
  permissionKeys,
  enableRbacSetupManagement,
  isDevUser,
}: {
  code: string;
  permissionKeys: Set<string>;
  enableRbacSetupManagement: boolean;
  isDevUser: boolean;
}): SetupPermission => {
  if (!enableRbacSetupManagement || isDevUser) {
    return SETUP_PERMISSIONS_ALL;
  }

  const permissionConfig = SETUP_PERMISSIONS_MAP.get(code);

  if (!permissionConfig) {
    return SETUP_PERMISSIONS_NONE;
  }

  const { view, manage, import: importPermission } = permissionConfig;

  return {
    hasView: permissionKeys.has(view) || permissionKeys.has(manage),
    hasManage: permissionKeys.has(manage),
    ...(importPermission && {
      hasImport: permissionKeys.has(importPermission),
    }),
  };
};
